/**
 * Whether or not a user is in a certain experiments variation.
 * @param  {Object} [experiments={}] The hash of the users current experiments
 * @param  {String} [experimentKey=''] Key for the experiment to check
 * @param  {Number} [variation=2] value to check the against
 * @return {Boolean}
*/

export const gigCardExperiments = (experiments = {}) => (experimentKey = '', variation = 2) => experiments[experimentKey] === variation;



// WEBPACK FOOTER //
// ./src/utils/gigCardExperiments/index.js